var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFreakdayLogoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny",
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    overflow: "visible",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#189963",
    points: "147.4,469.9 135.5,512.6 224.2,512.6 236.1,469.9 248,427.2 159.3,427.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "138.8,341.7 316.2,341.7 328.1,299 340,256.3 162.6,256.3 162.6,256.3 169.2,232.7 174.5,213.6  174.5,213.6 351.9,213.6 375.7,128.2 198.3,128.2 198.3,128.2 109.7,128.2 109.7,128.2 109.6,128.2 97.7,170.9 85.8,213.6  85.9,213.6 85.9,213.6 83.7,221.3 74,256.3 62,299 50.1,341.7 41,374.5 38.2,384.5 26.3,427.2 14.4,469.9 2.5,512.6 91.1,512.6  103,469.9 114.9,427.2 126.4,385.9 126.8,384.5 138.8,341.7  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M394,0h-1.1v0H234l0,0h-88.6l0,0H101L89.1,42.7l-5.4,19.4L81,71.9l-3.8,13.5h6.5v0h37.9l0,0h88.6l0,0H394 l0.1,0c16.3,0,29.6,13.3,29.6,29.7c0,2.3-0.3,4.6-0.8,6.8L422,125l-1.6,5.8l-1.4,5l-75.3,270c-3.6,12.6-15.4,21.4-28.5,21.4v0 h-22.8l-23.8,85.4h46.6v0c25.5,0,49.7-8.2,70-23.7c19.6-15,34-36.3,40.7-59.9l0.1-0.2l0,0l0,0l0,0l74.3-266.4l0.5-2l3.1-11.2 c0,0,0-0.1,0-0.1c0.7-2.2,1.3-4.3,1.8-6.4l0.1,0v-0.3c2.2-8.9,3.3-18.1,3.3-27.3C509,51.6,457.4,0,394,0z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreakdayLogoIcon);
export default __webpack_public_path__ + "static/media/freakday_logo_icon.b5e1fc33e2a592659ef11b6ddc3d5dbe.svg";
export { ForwardRef as ReactComponent };